const FONT_SIZES = {
  XXX_SMALL: "0.80rem",
  XX_SMALL: "0.85rem",
  X_SMALL: "0.90rem",
  SMALL: "0.95rem",
  MEDIUM: "1.00rem",
  LARGE: "1.20rem",
  X_LARGE: "1.40rem",
  XX_LARGE: "1.60rem",
  XXX_LARGE: "2.00rem",
  ULTRA: "2.40rem",
  MONSTER: "3.00rem"
};

export {
  FONT_SIZES
};
